import React from "react";
import { connect } from "react-redux";
import { Col, Row } from 'react-bootstrap';
import SVGGeoShape from '../../geo-region/SVGGeoShape';
import { roundOfAcres, Unit } from "../../../helpers/unit";
import { HARVESTING_WORK_TYPE_ID } from "../../../constants";
import { NumberLoader } from "../../widgets/Loader";

const WorkedKPI = (props) => {
    const { workTypeId, shapeDetails, workDetails, loadDetails, isRequestingFields,
        isRequestingLoads, isRequestingWorkedAcres, isRequestingWorkedEG } = props;
    const unit = Unit.getInstance();

    const workedAcres = workDetails ? unit.toArea(workDetails.workedAcres, 2) : 0;
    const workedEg = workDetails && workDetails.egList ? workDetails.egList : [];

    return <Col className="p-0">
        <Row className="completion-details">
            <Col>
                <div className="name">Total</div>
                <div className="value">{isRequestingFields ? <NumberLoader /> : roundOfAcres(shapeDetails.totalAcres)}</div>
            </Col>
            <Col>
                <div className="name">Worked</div>
                <div className="value">{isRequestingWorkedAcres ? <NumberLoader /> : roundOfAcres(workedAcres)}</div>
            </Col>
        </Row>
        <Row className="completion-details">
            <Col lg={60} md={6} sm={6} >
                <div className="name">Implements</div>
                <div className="value">{(isRequestingWorkedAcres || isRequestingWorkedEG) ? <NumberLoader /> : workedEg.length}</div>
            </Col>
            {(HARVESTING_WORK_TYPE_ID === workTypeId) && <Col>
                <div className="name">Loads</div>
                <div className="value">{isRequestingLoads ? <NumberLoader /> : loadDetails && loadDetails.loads ? loadDetails.loads : 0}</div>
            </Col>}
        </Row>
        <Row className="region-plot">
            <SVGGeoShape
                location={shapeDetails.location}
                location2={workDetails.workedLocation}
                color={shapeDetails.properties.fillColor}
                color2={"#ffc107"}
                width="122px" height="122px" />
        </Row>
    </Col>
}


const mapStateToProps = (state, ownProps) => {
    const fieldListById = state.farmMonitor.fieldListById.payload;
    const fieldLoadsById = state.farmMonitor.fieldLoadsById.payload;

    return ({
        shapeDetails: fieldListById[ownProps.shapeRefId] ? fieldListById[ownProps.shapeRefId] : null,
        isRequestingFields: state.farmMonitor.fieldListById.isRequesting,
        isRequestingLoads: state.farmMonitor.fieldLoadsById.isRequesting,
        isRequestingWorkedAcres: state.farmMonitor.workedById.isRequesting,
        isRequestingWorkedEG: state.farmMonitor.workedById.isRequestingWorkedEG,
        workDetails: state.farmMonitor.workedById.payload[`${ownProps.shapeRefId}_${ownProps.workTypeId}`],
        loadDetails: fieldLoadsById[`${ownProps.shapeRefId}_${ownProps.workTypeId}`]
            ? fieldLoadsById[`${ownProps.shapeRefId}_${ownProps.workTypeId}`] : null
    });
}

export default connect(mapStateToProps)(WorkedKPI);